import { makeObservable, observable } from 'mobx'
import { Model } from '../../infra/model'
import {
  WorkspacePostingAggregationDTO,
  WorkspacePostingStatusDTO,
} from './dtos/workspace-posting'
import { WorkspacePostingStatus } from './WorkspacePosting'

export class WorkspacePostingAggregation extends Model<
  WorkspacePostingAggregationDTO,
  WorkspacePostingAggregation
> {
  status: WorkspacePostingStatus = WorkspacePostingStatus.Null
  total: number = 0

  constructor() {
    super()
    makeObservable(this, {
      status: observable,
      total: observable,
    })
  }

  parse(attrs: WorkspacePostingAggregationDTO) {
    return {
      status: this.parseWorkspacePostingStatusDto(attrs.status),
      total: parseInt(attrs.total),
    }
  }

  parseWorkspacePostingStatusDto(
    dto: WorkspacePostingStatusDTO,
  ): WorkspacePostingStatus {
    switch (dto) {
      case WorkspacePostingStatusDTO.Active:
        return WorkspacePostingStatus.Active
      case WorkspacePostingStatusDTO.Cancelled:
        return WorkspacePostingStatus.Cancelled
      case WorkspacePostingStatusDTO.Closed:
        return WorkspacePostingStatus.Closed
      case WorkspacePostingStatusDTO.Draft:
        return WorkspacePostingStatus.Draft
      case WorkspacePostingStatusDTO.InReview:
        return WorkspacePostingStatus.InReview
      default:
        return WorkspacePostingStatus.Null
    }
  }
}
